// extracted by mini-css-extract-plugin
export default {"loader":"Loader-module__loader___Lxe2h"};